import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { NewHeader } from 'components/page-header'

interface Props {
  actionButton: ReactNode
}

export const Header: FC<Props> = ({ actionButton }) => {
  const { t } = useTranslation()

  return (
    <NewHeader
      title={t('common.projects')}
      renderRightSlot={() => actionButton}
    />
  )
}
